<template>
    <div class="home viewport-maxwidth">
        <v-progress-linear v-if="loading === true" indeterminate color="primary"></v-progress-linear>
        <!-- start of USER-INPUT -->
        <v-row class="mt-0 justify-center">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-window v-model="step">
                    <!-- STEP 1 - WELCOME / SELECT USER TYPE WINDOW -->
                    <v-window-item :value="1">
                        <v-form ref="formStep1">
                            <p class="mt-3 mb-0 text-left text-body-2 font-weight-bold">Please select your registration type:</p>
                            <v-divider></v-divider>
                            <v-radio-group v-model="form.userType" class="mt-5" :rules="rules.userType" @change="updateOrganisation">
                                <v-radio
                                    color="black"
                                    class="pl-2 mt-2 font-weight-bold text-h5"
                                    key="STAFF"
                                    label="TFW Rail Limited Employee"
                                    value="STAFF"
                                ></v-radio>
                                <div class="pl-10">I am employed by TFWRL directly and I wish to register for access to SWAPP.</div>
                                <v-radio
                                    color="black"
                                    class="pl-2 mt-2 font-weight-bold text-h5"
                                    key="CONTRACTOR"
                                    label="Contractor"
                                    value="CONTRACTOR"
                                ></v-radio>
                                <div class="pl-10">
                                    I work as a Contractor and require Site Access Permission or registering my organisation for the first time.
                                </div>
                                <v-radio
                                    color="black"
                                    class="pl-2 mt-2 font-weight-bold text-h5"
                                    key="VISITOR"
                                    label="Visitor (Including TFW Gov)"
                                    value="VISITOR"
                                ></v-radio>
                                <div class="pl-10">I have a meeting or requirement to visit a TFWRL Depot or Site and require a Visitor Pass.</div>
                            </v-radio-group>
                            <!--NEXT-BUTTON-->
                            <v-row class="my-4">
                                <v-col cols="6">
                                    <v-btn block depressed large @click="MIX_go('/login')" class="mt-3 grey lighten-1">{{
                                        $t('buttons.backLogin')
                                    }}</v-btn>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="6">
                                    <v-btn
                                        block
                                        depressed
                                        @click="validateStep1()"
                                        :loading="loading1"
                                        :disabled="loading1"
                                        large
                                        class="mt-3 darkgrey white--text"
                                        >{{ $t('buttons.next') }}</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-window-item>
                    <!-- STEP 2 - ORGANISATION / TFW SPONSOR WINDOW -->
                    <v-window-item :value="2">
                        <!-- <v-form v-if="form.userType === 'STAFF'" ref="sponsorForm"> 
                            <v-row >
                                <v-col cols="12" class="">         
                                    Please select a TFW Sponsor who can verify your registration.   
                                    
	    					    	<v-autocomplete
                                        color="black" 
                                        :label="$t(`fields.host`)" 
                                        class="text-capitalize" 
                                        v-model="form.host" 
                                        :items="staffContacts" 
                                        no-data-text="No TFW Sponsor found." 
                                        filled 
                                        hide-details="auto" 
                                        :rules="rules.host" 
                                        item-text="userName"  
                                        required 
                                        background-color="white" 
                                        dense 
                                        :clearable="true" 
                                        return-object
                                        auto-select-first
                                        >
			    			    		<template v-slot:item="data">{{ data.item.userName }} <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template>
		    				    		<template v-slot:selection="data">{{ data.item.userName }} <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template>
				    		    	</v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-form> -->
                        <v-row v-if="form.userType === 'CONTRACTOR' || form.userType === 'VISITOR'">
                            <v-col>
                                <v-row v-if="showOrganisationSelection">
                                    <v-col>
                                        Please search for your organisation:
                                        <v-autocomplete
                                            color="black"
                                            autocomplete="donotautocomplete"
                                            item-text="organisationName"
                                            :label="$t(`fields.organisation`)"
                                            v-model="form.organisation"
                                            :items="computedOrganisations"
                                            filled
                                            hide-details="auto"
                                            :rules="rules.organisation"
                                            required
                                            background-color="white"
                                            dense
                                            :clearable="true"
                                            return-object
                                        >
                                            <template v-slot:selection="data">{{ data.item.organisationName }}</template>
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row class="d-flex align-center" v-if="!showOrganisationForm">
                                    <v-col cols="12" md="9" class="pb-0"
                                        >If you are unable to find your organisation and are responsible for setting up, click [CREATE]</v-col
                                    >
                                    <v-col cols="12" md="3" height="100%" class="d-flex align-center justify-end pt-0">
                                        <v-btn
                                            v-if="$vuetify.breakpoint.smAndDown"
                                            depressed
                                            medium
                                            @click="
                                                showOrganisationSelection = false
                                                showOrganisationForm = true
                                            "
                                            class="mt-0 grey lighten-1"
                                            >{{ $t('buttons.createOrganisation') }}</v-btn
                                        >
                                        <v-btn
                                            v-else
                                            depressed
                                            medium
                                            @click="
                                                showOrganisationSelection = false
                                                showOrganisationForm = true
                                            "
                                            class="mt-4 grey lighten-1"
                                            >{{ $t('buttons.createOrganisation') }}</v-btn
                                        >
                                    </v-col>
                                </v-row>
                                <v-row v-if="form.userType === 'CONTRACTOR' && !showOrganisationForm">
                                    <v-col>
                                        Or if you are a sub-contractor, please enter your name here:
                                        <v-text-field
                                            color="black"
                                            :label="$t(`fields.subContractorName`)"
                                            v-model="form.subContractorName"
                                            filled
                                            hide-details="auto"
                                            :rules="rules.subContractor"
                                            required
                                            background-color="white"
                                            dense
                                            :clearable="true"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <transition
                                    name="custom-classes-transition"
                                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                                    mode="out-in"
                                >
                                    <v-row v-if="showOrganisationForm">
                                        <v-col cols="12" md="9"
                                            >Please enter your Organisation details or click [RETURN] to return to list of organisations.</v-col
                                        >
                                        <v-col cols="12" md="3" class="d-flex align-center justify-end pt-0">
                                            <v-btn
                                                depressed
                                                medium
                                                @click="
                                                    showOrganisationSelection = true
                                                    showOrganisationForm = false
                                                "
                                                class="grey lighten-1"
                                                >{{ $t('buttons.return') }}</v-btn
                                            >
                                        </v-col>
                                        <v-col cols="12">
                                            <v-form ref="organisationForm">
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.organisationName"
                                                    :label="$t('fields.organisationName')"
                                                    hide-details="auto"
                                                    :rules="rules.name"
                                                    required
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.organisationTelephone"
                                                    :label="$t('fields.telephone')"
                                                    hide-details="auto"
                                                    :rules="rules.telephone"
                                                    required
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.address.addressLine1"
                                                    :label="$t('fields.addressLine1')"
                                                    hide-details="auto"
                                                    :rules="rules.addressLine1"
                                                    required
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.address.addressLine2"
                                                    :label="$t('fields.addressLine2')"
                                                    hide-details="auto"
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.address.addressLine3"
                                                    :label="$t('fields.addressLine3')"
                                                    hide-details="auto"
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.address.town"
                                                    :label="$t('fields.town')"
                                                    hide-details="auto"
                                                    :rules="rules.town"
                                                    required
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.address.county"
                                                    :label="$t('fields.county')"
                                                    hide-details="auto"
                                                    :rules="rules.county"
                                                    required
                                                ></v-text-field>
                                                <v-text-field
                                                    autocomplete="donotautocomplete"
                                                    color="black"
                                                    filled
                                                    :background-color="inputBackgroundColor"
                                                    class="mb-1"
                                                    v-model="organisationForm.address.postcode"
                                                    :label="$t('fields.postcode')"
                                                    hide-details="auto"
                                                    :rules="rules.postcode"
                                                    required
                                                ></v-text-field>

                                                Please select the Site that you will be working at.
                                                <v-autocomplete
                                                    class="mb-1"
                                                    :menu-props="{ top: true, offsetY: true }"
                                                    :attach="true"
                                                    color="black"
                                                    :label="$t(`fields.site`)"
                                                    v-model="form.site"
                                                    :items="computedSites"
                                                    item-text="siteName"
                                                    return-object
                                                    filled
                                                    hide-details="auto"
                                                    :rules="rules.site"
                                                    required
                                                    background-color="white"
                                                >
                                                    <template v-slot:item="data">
                                                        {{ data.item.siteName }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.siteName }}
                                                    </template>
                                                </v-autocomplete>
                                                <!-- <pre>{{ form.site }} </pre> -->
                                                <div
                                                    v-if="
                                                        form.site.siteId !== '' &&
                                                        form.site.siteId !== null &&
                                                        form.site.siteId !== undefined &&
                                                        form.site.siteId !== '[]'
                                                    "
                                                >
                                                    Please select an TFWRL Sponsor who can verify your registration.
                                                    <v-autocomplete
                                                        color="black"
                                                        :menu-props="{ top: true, offsetY: true }"
                                                        :attach="true"
                                                        :label="$t(`fields.sponsor`)"
                                                        no-data-text="There are no TFW Sponsors for this Site"
                                                        v-model="organisationForm.orgApproval"
                                                        :items="computedStaffContacts"
                                                        filled
                                                        hide-details="auto"
                                                        :rules="rules.host"
                                                        required
                                                        background-color="white"
                                                        dense
                                                        clearable
                                                        @click:clear.prevent="
                                                            form.host = {
                                                                userId: '',
                                                                userName: '',
                                                                userEmail: '',
                                                                userJobTitle: ''
                                                            }
                                                        "
                                                        return-object
                                                    >
                                                        <template v-slot:item="data"
                                                            >{{ data.item.userName }}
                                                            <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template
                                                        >
                                                        <template v-slot:selection="data"
                                                            >{{ data.item.userName }}
                                                            <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template
                                                        >
                                                    </v-autocomplete>
                                                </div>
                                            </v-form>
                                        </v-col>
                                    </v-row>
                                </transition>
                            </v-col>
                        </v-row>
                        <!--NEXT-BUTTON-->
                        <v-row class="my-4">
                            <v-col cols="6">
                                <v-btn block depressed large @click="step--" class="mt-3 grey lighten-1">{{ $t('buttons.back') }}</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="6">
                                <v-btn block depressed @click="validateStep2()" :loading="loading1" :disabled="loading1" large class="mt-3 info">{{
                                    $t('buttons.next')
                                }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <!-- STEP 3 - CONTACT INFORMATION WINDOW -->
                    <v-window-item :value="3">
                        <v-row>
                            <v-col cols="12">
                                Please enter your Contact Information:<br />
                                <v-divider></v-divider>
                                <v-icon>mdi-asterisk</v-icon>
                                <span class="caption">Required</span>
                            </v-col>
                            <v-col>
                                <v-form ref="userForm">
                                    <!-- //* NAME - all -->
                                    <v-text-field
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.userName"
                                        :label="$t('fields.name')"
                                        append-icon="mdi-asterisk"
                                        hide-details="auto"
                                        :rules="rules.userName"
                                        required
                                    ></v-text-field>

                                    <!-- //* EMAIL - all -->
                                    <v-text-field
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model.trim="form.userEmail"
                                        :label="$t('fields.email')"
                                        append-icon="mdi-asterisk"
                                        hide-details="auto"
                                        :rules="rules.userEmail"
                                        required
                                    ></v-text-field>

                                    <!-- //* TELEPHONE - all -->
                                    <v-text-field
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.userTelephone"
                                        :label="$t('fields.telephone')"
                                        append-icon="mdi-asterisk"
                                        hide-details="auto"
                                        :rules="rules.userTelephone"
                                        required
                                    ></v-text-field>

                                    <!-- //* PTS CARD NUMBER - Staff  -->
                                    <v-text-field
                                        v-if="form.userType == 'STAFF'"
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.userPTSCardNo"
                                        label="Employee Number"
                                        hide-details="auto"
                                    ></v-text-field>

                                    <!-- //* JOB TITLE - Cont, Vis  -->
                                    <v-text-field
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.userJobTitle"
                                        :label="$t('fields.jobTitle')"
                                        append-icon="mdi-asterisk"
                                        hide-details="auto"
                                        :rules="rules.userJobTitle"
                                        required
                                    ></v-text-field>

                                    <!-- //* HOST / SPONSOR  - Cont, Vis -->
                                    <v-autocomplete
                                        v-if="form.userType === 'CONTRACTOR' || form.userType === 'VISITOR'"
                                        color="black"
                                        :label="$t(`fields.host`)"
                                        class="text-capitalize mb-1"
                                        v-model="form.host"
                                        :items="computedStaffContacts"
                                        filled
                                        item-text="userName"
                                        hide-details="auto"
                                        :rules="rules.host"
                                        required
                                        background-color="white"
                                        dense
                                        return-object
                                    >
                                        <template v-slot:item="data" class="text-capitalize"
                                            >{{ data.item.userName }}
                                            <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template
                                        >
                                        <template v-slot:selection="data" class="text-capitalize"
                                            >{{ data.item.userName }}
                                            <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template
                                        >
                                    </v-autocomplete>

                                    <!-- //* PTS CARD NUMBER - Cont  -->
                                    <v-text-field
                                        v-if="form.userType == 'CONTRACTOR'"
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.userPTSCardNo"
                                        :label="$t('fields.ptsCardNo')"
                                        hide-details="auto"
                                    ></v-text-field>

                                    <!-- //* EMERGENCY CONTACT SECTION - Contractor only -->
                                    <v-col class="my-2 mt-4 px-0" cols="12" v-if="form.userType === 'CONTRACTOR'">
                                        <h5 class="grey--text text--darken-1">EMERGENCY CONTACT</h5>
                                        <v-divider class="" />
                                    </v-col>

                                    <!-- //* EMERGENCY CONTACT NAME - Contractor only -->
                                    <v-text-field
                                        v-if="form.userType === 'CONTRACTOR'"
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.emergencyContactName"
                                        label="Emergency Contact Name"
                                        append-icon="mdi-asterisk"
                                        hide-details="auto"
                                        :rules="rules.emergencyContactName"
                                        required
                                    ></v-text-field>

                                    <!-- //* EMERGENCY CONTACT PHONE - Contractor only -->
                                    <v-text-field
                                        v-if="form.userType === 'CONTRACTOR'"
                                        autocomplete="donotautocomplete"
                                        color="black"
                                        filled
                                        :background-color="inputBackgroundColor"
                                        class="mb-1"
                                        v-model="form.emergencyContactPhone"
                                        label="Emergency Contact Phone"
                                        append-icon="mdi-asterisk"
                                        hide-details="auto"
                                        :rules="rules.emergencyContactPhone"
                                        required
                                        type="number"
                                    ></v-text-field>

                                    <!-- //* SITE - Staff  -->
                                    <v-autocomplete
                                        v-if="form.userType === 'STAFF'"
                                        class="mb-1"
                                        :menu-props="{ top: false, offsetY: true }"
                                        :attach="true"
                                        color="black"
                                        :label="$t(`fields.site`)"
                                        v-model="form.site"
                                        :items="computedSites"
                                        item-text="siteName"
                                        return-object
                                        filled
                                        hide-details="auto"
                                        :rules="rules.site"
                                        required
                                        background-color="white"
                                    >
                                        <template v-slot:item="data">
                                            {{ data.item.siteName }}
                                        </template>
                                        <template v-slot:selection="data">
                                            {{ data.item.siteName }}
                                        </template>
                                    </v-autocomplete>

                                    <!-- //* FUNCTION - Staff  -->
                                    <v-autocomplete
                                        v-if="form.userType === 'STAFF'"
                                        class="mb-1"
                                        :menu-props="{ top: false, offsetY: true }"
                                        :attach="true"
                                        color="black"
                                        label="Functions (Dept)"
                                        v-model="form.function"
                                        :items="functions"
                                        item-text="siteName"
                                        return-object
                                        filled
                                        hide-details="auto"
                                        :rules="rules.function"
                                        required
                                        background-color="white"
                                    ></v-autocomplete>

                                    <!-- //* HOST / SPONSOR  - Staff -->
                                    <v-autocomplete
                                        v-if="form.userType === 'STAFF'"
                                        :disabled="form.site.siteId == '' || form.function == ''"
                                        color="black"
                                        :label="$t(`fields.host`)"
                                        class="text-capitalize mb-1"
                                        v-model="form.host"
                                        :items="staffContacts"
                                        filled
                                        hide-details="auto"
                                        :rules="rules.host"
                                        required
                                        background-color="white"
                                        dense
                                        return-object
                                    >
                                        <template v-slot:item="data" class="text-capitalize"
                                            >{{ data.item.userName }}
                                            <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template
                                        >
                                        <template v-slot:selection="data" class="text-capitalize"
                                            >{{ data.item.userName }}
                                            <span class="caption grey--text pl-1"> ({{ data.item.userJobTitle }})</span></template
                                        >
                                    </v-autocomplete>
                                    <!-- <pre>{{ form.host }}</pre> -->

                                    <br />
                                    <v-expansion-panels flat>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header color="appbackground" class="pa-0 ma-0">{{
                                                $t('fields.medicallyFit')
                                            }}</v-expansion-panel-header>
                                            <v-expansion-panel-content color="appbackground">
                                                A person has reached a state of clinical or physiological stability that is unlikely to be associated
                                                with the need for further inpatient hospital care in the near-future.
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                    <v-radio-group row v-model="form.userMedicallyFit" :rules="rules.userMedicallyFit">
                                        <v-radio color="black" class="pl-3 mt-2 text-h6" key="YES" label="Yes" :value="true"></v-radio>
                                        <v-radio color="black" class="pl-3 mt-2 text-h6" key="NO" label="No" :value="false"></v-radio>
                                    </v-radio-group>
                                    <v-expansion-panels flat>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header color="appbackground" class="pa-0 ma-0">{{
                                                $t('fields.vulnerablePerson')
                                            }}</v-expansion-panel-header>
                                            <v-expansion-panel-content color="appbackground">
                                                A vulnerable person is either a minor or someone who, for physical or mental reasons, is unable to
                                                look after themselves or their finances.
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                    <v-radio-group row v-model="form.userVulnerablePerson" :rules="rules.userVulnerablePerson">
                                        <v-radio color="black" class="pl-3 mt-2 text-h6" key="YES" label="Yes" :value="true"></v-radio>
                                        <v-radio color="black" class="pl-3 mt-2 text-h6" key="NO" label="No" :value="false"></v-radio>
                                    </v-radio-group>
                                    <v-checkbox
                                        class="my-2 ml-3"
                                        color="black"
                                        v-model="form.userAcceptTerms"
                                        :rules="rules.userAcceptTerms"
                                        :label="$t('fields.acceptTerms')"
                                        hide-details="auto"
                                        required
                                    ></v-checkbox>
                                </v-form>
                            </v-col>
                        </v-row>
                        <!-- <pre>{{ form }}</pre>
                        <pre>{{ organisationForm}}</pre> -->
                        <!--NEXT-BUTTON-->
                        <v-row class="my-4">
                            <v-col cols="6">
                                <v-btn v-if="form.userType == 'STAFF'" block depressed large @click="step = 1" class="mt-3 grey lighten-1">{{
                                    $t('buttons.back')
                                }}</v-btn>
                                <v-btn v-else block depressed large @click="step--" class="mt-3 grey lighten-1">{{ $t('buttons.back') }}</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="6">
                                <v-btn block depressed @click="validateStep3()" large class="mt-3 info">{{ $t('buttons.next') }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <!-- STEP 4 - PASSWORD WINDOW -->
                    <v-window-item :value="4">
                        <!-- PASSWORD FORM -->
                        <v-form ref="passwordForm">
                            <v-text-field
                                v-model.trim="password"
                                filled
                                :background-color="inputBackgroundColor"
                                class="mb-1"
                                hide-details="auto"
                                :label="$t('fields.password')"
                                :append-icon="showPasswordIcon ? 'icons8-eye' : 'icons8-invisible'"
                                :type="showPasswordIcon ? 'text' : 'password'"
                                @click:append="showPasswordIcon = !showPasswordIcon"
                                :rules="rules.passwordRules"
                                required
                            ></v-text-field>
                            <v-text-field
                                v-model.trim="confirmPassword"
                                filled
                                :background-color="inputBackgroundColor"
                                class="mb-2"
                                hide-details="auto"
                                :label="$t('fields.confirmPassword')"
                                :append-icon="showPasswordIcon1 ? 'icons8-eye' : 'icons8-invisible'"
                                :type="showPasswordIcon1 ? 'text' : 'password'"
                                @click:append="showPasswordIcon1 = !showPasswordIcon1"
                                :rules="rules.passwordRules"
                                required
                            ></v-text-field>
                        </v-form>
                        <!-- <pre>{{ form }}</pre>
                        <pre>{{ organisationForm}}</pre> -->
                        <!-- BUTTONS -->
                        <v-row class="my-4">
                            <v-col cols="6">
                                <v-btn block depressed large @click="step--" class="mt-3 grey lighten-2">{{ $t('buttons.back') }}</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="6">
                                <v-btn block depressed large @click="validateStep4()" :loading="loading" :disabled="loading" class="mt-3 info">{{
                                    $t('buttons.register')
                                }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <!-- STEP 5 - CONFIRMATION -->
                    <v-window-item :value="5">
                        <div class="pa-4 text-center" v-if="accountCreated === true">
                            <v-progress-linear indeterminate color="primary"></v-progress-linear>
                            <h3 class="title font-weight-light mb-2">Welcome</h3>
                            <span class="caption grey--text">Thanks for signing up! You will be redirected to the home page</span>
                        </div>
                        <div class="pa-4 text-center" v-else>
                            <h3 class="title font-weight-light mb-2">Something went wrong</h3>
                            <h4 v-if="registerErrorMessage != null">
                                {{ registerErrorMessage }}
                            </h4>
                            <v-btn block depressed large @click="step = 1" class="mt-3 grey lighten-2">{{ $t('buttons.tryagain') }}</v-btn>
                        </div>
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
        <!-- <v-row style="width: 100vh !important;">
            <v-col cols="6">
                User Form<br />
                <pre>{{ form }}</pre>
            </v-col>
            <v-col cols="6">
                OrganisationForm<br />
                <pre>{{ organisationForm }}</pre>
            </v-col>
        </v-row> -->
        <!-- end of USER-INPUT -->
        <v-dialog style="z-index: 3000 !important" v-model="privacyDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card class="background">
                <v-toolbar dark color="secondary heading5 black--text">
                    Privacy and Terms & Conditions
                    <v-spacer></v-spacer>
                    <v-icon class="black--text" @click="privacyDialog = false">mdi-close</v-icon>
                </v-toolbar>
                <!-- <PrivacyTermsConditions /> -->
                <v-divider></v-divider>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import PrivacyTermsConditions from "@/components/termsAndConditions.vue";
export default {
    name: 'Register',
    data: () => ({
        showOrganisationSelection: true,
        showOrganisationForm: false,
        inputBackgroundColor: 'white',
        step: 1,
        valid: true,
        valid1: true,
        showPasswordIcon: false,
        showPasswordIcon1: false,
        adminRegCode: '',
        form: {
            id: '',
            swappMethod: null, //default null
            swappStatus: 0, //default 0
            userContactType: '', // Left Blank
            userEmail: '', // Required
            userJobTitle: '', // Required
            userName: '', // Required
            userRole: 'USER', // Always set to USER
            userStaffContact: false, // Always False on Registration
            userStatus: 'PENDING', // Always PENDING on Registration
            userTelephone: '', // Required
            userType: '', // Require // TODO REMOVE CONTRACTOR
            userPTSCardNo: '',
            userVulnerablePerson: null,
            userMedicallyFit: null,
            userAcceptTerms: null,
            inductionDate: '',
            userEmailVerified: false,
            host: {
                // userId: '',
                // userEmail: '',
                // userName: '',
                // userJobTitle: '',
                // organisationId: '',
                // organisationName: ''
            },
            site: {
                siteId: ''
            },
            function: '',
            createdDateTime: '',
            createdUserData: [],
            modifiedDateTime: '',
            modifiedDateTime: [],
            organisation: {
                organisationId: '',
                organisationName: '',
                organisationType: '',
                host: []
            },
            subContractorName: '',
            idFieldId: null,
            lastLocation: {
                locationId: '',
                locationName: ''
            },
            lastSite: {
                siteId: '',
                siteName: ''
            },
            profilePicFileURL: null,
            emergencyContactName: '',
            emergencyContactPhone: ''
        },
        organisationForm: {
            organisationName: '',
            organisationTelephone: '',
            address: {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                town: '',
                county: '',
                postcode: ''
            },
            organisationType: '',
            organisationStatus: 'PENDING',
            orgApproval: {
                userName: '',
                userEmail: '',
                userId: '',
                userJobTitle: '',
                organisationId: '',
                organisationName: ''
            },
            host: {
                userName: '',
                userEmail: '',
                userId: '',
                userJobTitle: '',
                organisationId: '',
                organisationName: ''
            }
        },
        password: '', // password input
        confirmPassword: '', // check password
        accountCreated: true, // show thank you/ try gain message at the end
        loading: false,
        loader1: null,
        loading1: false,
        privacyDialog: false,
        lookupValues: [],
        rules: {},
        integration: [],
        registerErrorMessage: null,
        userInLocalStorage: false,
        userInLocalStorageId: null,
        organisations: [],
        sites: [],
        staffContactResult: [],
        visitorOrganisations: [],
        functions: [
            'Production',
            'Engineering',
            'Shunters',
            'Maintenance Control',
            'Planning',
            'Stores',
            'Facilities',
            'Train Presentation',
            'Fleet Readiness'
        ]
    }),
    watch: {
        // loader1() {
        //     const l = this.loader1;
        //     this[l] = !this[l];
        //     setTimeout(() => (this[l] = false), 3000);
        //     this.loader1 = null;
        // },
    },
    computed: {
        computedOrganisations() {
            if (this.form.userType === 'CONTRACTOR') {
                return this.organisations.filter(function (o) {
                    return o.organisationId !== 'UshqEqj4OeCGI4JHMjUk'
                })
            }
            // console.log(JSON.stringify(this.organisations, null, 2))
            return this.organisations
        },
        computedSites() {
            var t = this
            var sites = t.sites

            sites = sites.filter(function (item) {
                if (item.delete) {
                } else {
                    return item
                }
            })
            // console.log("sites = " + JSON.stringify(sites, null, 2))

            return sites
        },
        // * Checks if the password matches the confirm password
        passwordConfirmationRule() {
            return () => this.password === this.confirmPassword || 'Password must match'
        },
        computedStaffContacts() {
            var t = this
            var users = this.staffContactResult
            users = users.sort((a, b) => a.userName.localeCompare(b.userName))
            // console.log("site = " + JSON.stringify(this.form.site, null, 2))
            if (
                this.form.site.siteId !== [] &&
                this.form.site.siteId !== null &&
                this.form.site.siteId !== undefined &&
                this.form.site.siteId !== ''
            ) {
                // console.log("users 1 = " + JSON.stringify(users, null, 2))

                // users = users.filter(function(s) {
                //     return s.userContactType !== ''
                // })
                // console.log("users 2 = " + JSON.stringify(users, null, 2))
                // console.log("site 2 = " + JSON.stringify(this.form.site.siteId, null, 2))
                users = users.filter(function (s) {
                    return s.site
                })

                users = users.filter(function (item) {
                    return item.site && item.site.siteId == t.form.site.siteId
                })

                // console.log("users 3 = " + JSON.stringify(users, null, 2))
                return users
            } else {
                return users
            }
        },
        staffContacts() {
            var t = this
            var staffResult = this.staffContactResult.sort((a, b) => a.userName.localeCompare(b.userName))

            if (
                this.form.userType === 'STAFF' &&
                this.form.site.siteId !== '' &&
                this.form.site.siteId !== null &&
                this.form.site.siteId !== undefined &&
                this.form.site.siteId !== '[]'
            ) {
                // filter by site
                staffResult = staffResult.filter(function (item) {
                    return item.site && item.site.siteId == t.form.site.siteId
                })
            }
            // filter by function if staff
            if (this.form.userType == 'STAFF' && this.form.function !== '') {
                staffResult = staffResult.filter(function (item) {
                    return item.function == t.form.function || (item.function !== undefined && item.function.includes(t.form.function))
                })
            }
            return staffResult
            // .filter(function(s) {
            //     return s.userContactType !== ''
            // })
        }
    },
    methods: {
        ...mapActions({
            ACT_currentUser: 'ACT_currentUser'
        }),
        clearField(field) {
            // console.log('clear field running')
            this.form.host.userId = 'test'
            //{ userId: '', userName: '', userEmail: '', userJobTitle: '' }
        },
        updateOrganisation() {
            // this.form.organisation = [];
            if (this.form.userType === 'STAFF') {
                var staffOrganisation = this.organisations.find(function (e) {
                    return e.organisationId === 'UshqEqj4OeCGI4JHMjUk'
                })
                this.form.organisation = staffOrganisation
                // console.log("org = " + JSON.stringify(this.form.organisation, null, 2))
            } else {
                this.form.organisation = {
                    organisationId: '',
                    organisationName: '',
                    organisationType: '',
                    host: []
                }
            }
        },

        // * VALIDATE CONTACT DETAILS
        validateStep1() {
            let t = this
            t.rules = {
                userType: [(v) => !!v || 'You must select an option to continue.']
            }
            t.$nextTick(() => {
                if (t.$refs.formStep1.validate()) {
                    if (t.form.userType === 'STAFF') {
                        // go to step 3
                        t.step = 3
                    } else {
                        t.step++
                    }
                } else {
                    t.MIX_alert(-1, 'Please fill out all the fields', null, null)
                }
            })
        },
        validateStep2() {
            let t = this
            if (t.form.userType === 'STAFF') {
                t.rules = {
                    host: [(v) => !!v || 'TFW Sponsor is required']
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if (t.$refs.sponsorForm.validate()) {
                        if (t.form.host !== undefined && t.form.host.userId !== '') {
                            t.step++
                        } else {
                            t.MIX_alert(-1, 'You must select a TFW Sponsor to Verify your Account', null, null)
                        }
                    } else {
                        t.MIX_alert(-1, 'Please fill out all the fields', null, null)
                    }
                })
            } else {
                if (t.form.subContractorName) {
                    // console.log("got here " + JSON.stringify(t.form.subContractorName, null, 2))
                    if (
                        t.form.organisation !== undefined &&
                        t.form.organisation !== null &&
                        t.form.organisation.organisationId !== '' &&
                        t.form.organisation !== [] &&
                        t.form.organisation !== '[]'
                    ) {
                        // console.log("down here form = " + JSON.stringify(t.form.organisation, null, 2))
                        t.step++
                    } else {
                        t.MIX_alert(-1, 'Please Select an Organisation to continue', null, null)
                    }
                } else if (
                    t.form.organisation !== undefined &&
                    t.form.organisation !== null &&
                    t.form.organisation.organisationId !== '' &&
                    t.form.organisation !== [] &&
                    t.form.organisation !== '[]'
                ) {
                    // console.log("down here form = " + JSON.stringify(t.form.organisation, null, 2))
                    t.step++
                } else if (t.showOrganisationForm) {
                    t.rules = {
                        name: [(v) => !!v || 'Name is required', (v) => (v && v.length < 255) || 'Name must be less than 255 characters'],
                        telephone: [(v) => !!v || 'Telephone Number is Required'],
                        addressLine1: [
                            (v) => !!v || 'Address Line 1 is required',
                            (v) => (v && v.length < 255) || 'Address Line 1 must be less than 255 characters'
                        ],
                        addressLine2: [
                            (v) => !!v || 'Address Line 2 is required',
                            (v) => (v && v.length < 255) || 'Address Line 2 must be less than 255 characters'
                        ],
                        addressLine3: [
                            (v) => !!v || 'Address Line 3 is required',
                            (v) => (v && v.length < 255) || 'Address Line 3 must be less than 255 characters'
                        ],
                        town: [(v) => !!v || 'Town is required', (v) => (v && v.length < 255) || 'Town must be less than 255 characters'],
                        county: [(v) => !!v || 'County is required', (v) => (v && v.length < 255) || 'County must be less than 255 characters'],
                        postcode: [(v) => !!v || 'Postcode is required', (v) => (v && v.length < 255) || 'Postcode must be less than 255 characters'],
                        host: [(v) => !!v || 'TFW Sponsor is required']
                    }
                    //let the DOM update
                    t.$nextTick(() => {
                        //manually trigger Vuetify validation
                        if (t.$refs.organisationForm.validate()) {
                            //                                if (t.form.host !== undefined && t.form.host.userId !== '') {
                            if (t.organisationForm.orgApproval !== undefined && t.organisationForm.orgApproval.userId !== '') {
                                t.step++
                            } else {
                                t.MIX_alert(-1, 'You must select a TFW Sponsor to Verify your Account', null, null)
                            }
                        } else {
                            t.MIX_alert(-1, 'Please fill out all the fields', null, null)
                        }
                    })
                } else {
                    t.MIX_alert(-1, 'Please Select or Create an Organisation to continue', null, null)
                }
            }
        },
        validateStep3() {
            let t = this
            t.rules = {
                userName: [
                    (v) => !!v || 'Name is required',
                    (v) => (v && v.length < 255) || 'Name must be less than 255 characters',
                    (v) => (v && v !== ' ') || 'Name must not be empty'
                ],
                userTelephone: [
                    (v) => !!v || 'Telephone Number is Required',
                    (v) => (v && v !== ' ') || 'Telephone Number must not be empty'
                    // v => (v && v.length !== 11) || 'Telephone Number must be valid',
                    // ^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$
                ],
                userEmail: [(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
                userJobTitle: [
                    (v) => !!v || 'Job Title is required',
                    (v) => (v && v.length < 255) || 'Job Title must be less than 255 characters',
                    (v) => (v && v !== ' ') || 'Job Title must not be empty'
                ],
                host: [
                    (v) => !!v || 'TFW Sponsor is required',
                    (v) => (t.form.host.id && t.form.host.id !== undefined && t.form.host.id !== '') || 'TFW Sponsor is required'
                ],
                site: [
                    (v) => !!v || 'Site is required',
                    (v) => (t.form.site.siteId && t.form.site.siteId !== undefined && t.form.site.siteId !== '') || 'Site is required'
                ],
                function: [(v) => !!v || 'Function is required'],
                userMedicallyFit: [(v) => v !== null || 'You must select an option'],
                userVulnerablePerson: [(v) => v !== null || 'You must select an option'],
                userAcceptTerms: [(v) => (v !== null && v !== false) || 'You must accept the Terms and Conditions'],
                emergencyContactName: [
                    (v) => t.form.userType !== 'CONTRACTOR' || !!v || 'Emergency Contact Name is required',
                    (v) => t.form.userType !== 'CONTRACTOR' || (v && v.length < 255) || 'Emergency Contact Name must be less than 255 characters',
                    (v) => t.form.userType !== 'CONTRACTOR' || (v && v !== ' ') || 'Emergency Contact Name must not be empty'
                ],
                emergencyContactPhone: [
                    (v) => t.form.userType !== 'CONTRACTOR' || !!v || 'Emergency Contact Phone is required',
                    (v) => t.form.userType !== 'CONTRACTOR' || (v && v !== ' ') || 'Emergency Contact Phone must not be empty'
                ]
            }
            //let the DOM update
            t.$nextTick(() => {
                //manually trigger Vuetify validation
                var validEmailDomains = ['vindico.net', 'tfwrail.wales', 'tfw.wales']
                if (t.$refs.userForm.validate()) {
                    switch (true) {
                        case t.form.userType === 'STAFF' && validEmailDomains.includes(t.form.userEmail.split('@')[1]):
                            t.step++
                            break
                        case t.form.userType === 'STAFF' && !validEmailDomains.includes(t.form.userEmail.split('@')[1]):
                            t.MIX_alert(-1, 'You must have a TFW authorised email address to continue', null, null)
                            break
                        case t.form.userType === 'VISITOR' || t.form.userType === 'CONTRACTOR':
                            t.step++
                            break
                        default:
                            t.MIX_alert(-1, 'Please fill out all the fields', null, null)
                            break
                    }
                }
            })
        },
        // * VALIDATE STEP 4
        validateStep4() {
            let t = this
            t.rules = {
                passwordRules: [(v) => !!v || 'Password is required']
            }
            //let the DOM update
            t.$nextTick(() => {
                if (t.$refs.passwordForm.validate()) {
                    switch (true) {
                        case this.password === this.confirmPassword:
                            t.register()
                            break
                        default:
                            t.MIX_alert(-1, 'Password does not match', null, null)
                            break
                    }
                }
            })
        },
        // next: async function() {
        //     if (this.$refs.registerUser.validate()) {
        //         if (this.$route.params.id ==='admin') {
        //           let result = await this.MIX_FIREBASE_checkAdminRegCode(this.adminRegCode)
        //           if ((result.code === 1) && (result.data === true)) {
        //               this.form.userLevel = 'SA'
        //               this.form.userRole = 'Admin';
        //               this.form.userType = 'Staff';
        //               this.step++; // * move to the next step
        //               console.log('this.form.userLevel = ' + this.form.userLevel )
        //           } else {
        //               this.MIX_alert(-1, 'Admin Registration Code is Incorrect, please try again.')
        //           }
        //         } else {
        //               this.step++; // * move to the next step
        //         }
        //     } else {
        //       // ! did not pass validation
        //       this.MIX_alert(-1, 'Fill out all the fields correctly in order to proceed.', null, null);
        //     }
        // },
        // async checkUserInLocalStorage(email){
        //     var t = this;
        //     return new Promise(function(resolve, reject) {
        //         t.$firebase.db.collection("users").where('userEmail', '==', email).get().then(function(querySnapshot) {
        //             if (querySnapshot.docs.length === 0) {
        //                 t.userInLocalStorage = false;
        //                 return resolve(t.userInLocalStorage);
        //             } else {
        //                 t.userInLocalStorage = true;
        //                 t.userInLocalStorageId = querySnapshot.docs[0].id;
        //                 return resolve(t.userInLocalStorage);
        //             }
        //         })
        //         .catch(function(error) {
        //             // console.log("Error getting documents: ", error);
        //             return reject(error)
        //         });
        //     });
        // },
        // setUserDetails(uid){
        //     var t = this;
        //     t.form.id = uid; // * assign firebase auth user id to firebase user in collection
        //     t.form.createdDateTime = t.$moment().format("x");
        //     t.form.createdUserData.userEmail = t.form.userEmail;
        //     t.form.createdUserData.userName = t.form.userName;
        //     t.form.createdUserData.userId = uid;
        // },
        // sendVerificationEmail(currentUser) {
        //     var t = this;
        //     var currentUser = currentUser;
        //     currentUser.sendEmailVerification().then(function() {
        //         t.MIX_alert(2, "An account verification email has been sent to you.", null, null);
        //     })
        //     .catch(function(error) {
        //         // ! verification email error
        //         console.log("send verification email error: " + error);
        //         t.MIX_alert(-1, error, null, null);
        //     });
        // },
        // createUserAccount() {
        //     return new Promise((resolve) => {
        //         let t = this;
        //         t.$firebase.auth.createUserWithEmailAndPassword(t.form.userEmail, t.password).then(async (data) => {
        //             t.form.id = data.user.uid;
        //             // Update Created By / Modified By
        //             var userData = {}
        //             userData.createdUserData = {
        //                 userId: t.form.id,
        //                 userName: t.form.userName,
        //                 userEmail: t.form.userEmail,
        //                 organisationId: t.form.organisation.organisationId,
        //                 organisationName: t.form.organisation.organisationName,
        //             }
        //             t.form.createdUserData = userData.createdUserData
        //             t.form.createdDateTime = t.$moment().format('x'); // add created timestamp to document
        //             t.form.modifiedUserData = userData.createdUserData
        //             t.form.modifiedDateTime = t.$moment().format('x'); // add created timestamp to document

        //             // console.log('t.form.id = ' + t.form.id)
        //             // var createDocumentResult = await t.MIX_createDocument('users', t.form)
        //             // console.log('createDocumentResult = ' + JSON.stringify(createDocumentResult, null, 2))
        //             // if (createDocumentResult.code === 1) {
        //             //     resolve({ code: 1, message: 'Account Created', data: createDocumentResult.data, error: null });
        //             // } else {
        //             //     resolve({ code: -1, message: 'ERROR Creating Account', data: null, error: err });
        //             // }
        //             t.$firebase.db.collection("users").doc(data.user.uid).set(t.form).then((result) => {
        //                 resolve({ code: 1, message: 'Account Created', data: data, error: null });
        //             }).catch((err) => {
        //                 console.log(err);
        //                 resolve({ code: -1, message: 'ERROR Creating Account', data: null, error: err });
        //             });
        //         })
        // 	    .catch((err) => {
        // 	        // ! firebase registering error
        //             console.log('err = ' + err)
        // 	        t.registerErrorMessage = err;
        // 	        t.accountCreated = false;
        // 	        resolve({ code: -1, message: 'ERROR Creating Account: ' + err, data: null, error: err });
        //         });
        //     })
        // },
        createUserAccount() {
            return new Promise((resolve) => {
                let t = this
                t.$firebase.auth
                    .createUserWithEmailAndPassword(t.form.userEmail, t.password)
                    .then(async (data) => {
                        t.form.id = data.user.uid
                        if (this.form.userType === 'STAFF') {
                            var staffOrganisation = this.organisations.find(function (e) {
                                return e.organisationId === 'UshqEqj4OeCGI4JHMjUk'
                            })
                            this.form.organisation = staffOrganisation
                        }
                        // Update Created By / Modified By
                        var userData = {}
                        userData.createdUserData = {
                            userId: t.form.id,
                            userName: t.form.userName,
                            userEmail: t.form.userEmail,
                            organisationId: t.form.organisation.organisationId,
                            organisationName: t.form.organisation.organisationName
                        }
                        t.form.createdUserData = userData.createdUserData
                        t.form.createdDateTime = t.$moment().format('x') // add created timestamp to document
                        t.form.modifiedUserData = userData.createdUserData
                        t.form.modifiedDateTime = t.$moment().format('x') // add created timestamp to document

                        // console.log('t.form.id = ' + t.form.id)
                        // var createDocumentResult = await t.MIX_createDocument('users', t.form)
                        // console.log('createDocumentResult = ' + JSON.stringify(createDocumentResult, null, 2))
                        // if (createDocumentResult.code === 1) {
                        //     resolve({ code: 1, message: 'Account Created', data: createDocumentResult.data, error: null });
                        // } else {
                        //     resolve({ code: -1, message: 'ERROR Creating Account', data: null, error: err });
                        // }
                        t.$firebase.db
                            .collection('users')
                            .doc(data.user.uid)
                            .set(t.form)
                            .then((result) => {
                                resolve({
                                    code: 1,
                                    message: 'Account Created',
                                    data: data,
                                    error: null
                                })
                            })
                            .catch((err) => {
                                console.log(err)
                                resolve({
                                    code: -1,
                                    message: 'ERROR Creating Account',
                                    data: null,
                                    error: err
                                })
                            })
                    })
                    .catch((err) => {
                        // ! firebase registering error
                        console.log('err = ' + err)
                        t.registerErrorMessage = err
                        t.accountCreated = false
                        resolve({
                            code: -1,
                            message: 'ERROR Creating Account 2: ' + err,
                            data: null,
                            error: err
                        })
                    })
            })
        },
        updateDocument: function (collection, id, fields) {
            var t = this
            return new Promise(function (resolve) {
                fields = JSON.parse(JSON.stringify(fields))
                t.$firebase.db
                    .collection(collection)
                    .doc(id)
                    .update(fields)
                    .then(() =>
                        resolve({
                            code: 1,
                            message: 'Fields Updated in Document',
                            data: { id: document.id },
                            error: null
                        })
                    )
                    .catch((error) =>
                        resolve({
                            code: -1,
                            message: 'Error Writing Fields to Document',
                            data: null,
                            error: error
                        })
                    )
            })
        },
        createOrganisation() {
            return new Promise(async (resolve) => {
                let t = this
                // if (t.organisationForm.id === undefined) {
                t.organisationForm.id = t.MIX_generateId() // if new then generate new id
                // }
                // console.log("org id = " + JSON.stringify(t.organisationForm.id, null, 2))

                // var createDocumentResult = await t.MIX_createDocument('organisations', t.organisationForm)
                // if (createDocumentResult.code === 1) {
                //     resolve({ code: 1, message: 'Organisation Created', data: createDocumentResult.data, error: null });
                // } else {
                //     resolve({ code: -1, message: 'ERROR Creating Organisation', data: null, error: err });
                // }
                // .add(document)
                //                         firebase.db.collection(collectionName).add(document)
                //                             .then((document) => resolve ({ code: 1, message: 'Document Written to Collection', data: { id: document.id }, error: null }))

                t.$firebase.db
                    .collection('organisations')
                    .doc(t.organisationForm.id)
                    .set(t.organisationForm)
                    .then((document) => {
                        resolve({
                            code: 1,
                            message: 'Organisation Created',
                            data: document,
                            error: null
                        })
                    })
                    .catch((err) => {
                        console.log(err)
                        resolve({
                            code: -1,
                            message: 'ERROR Creating Organisation',
                            data: null,
                            error: err
                        })
                    })
                // t.$firebase.db.collection("organisations").set(t.organisationForm.id).then((document) => {
                //     resolve({ code: 1, message: 'Organisation Created', data: document.id, error: null });
                // }).catch((err) => {
                //     console.log(err);
                //     resolve({ code: -1, message: 'ERROR Creating Organisation', data: null, error: err });
                // });
            })
        },
        async register() {
            var t = this
            // debugger
            // this.step++; // * move to the next step
            t.form.userEmail = t.form.userEmail.toLowerCase() // set email to lowercase
            var createUserAccountResult, createOrganisationResult
            //console.log('t.form.userType = ' + t.form.userType)
            switch (t.form.userType) {
                case 'STAFF':
                    // Create New User Account on Firebase Auth / Firestore
                    createUserAccountResult = await t.createUserAccount()
                    //console.log('createUserAccountResult = ' + JSON.stringify(createUserAccountResult, null, 2))
                    t.MIX_alert(
                        createUserAccountResult.code,
                        createUserAccountResult.message,
                        createUserAccountResult.data,
                        createUserAccountResult.error
                    )
                    t.form.id = createUserAccountResult.data.user.uid // Update User ID from Firestore
                    //console.log('userData = ' + JSON.stringify(userData, null, 2))
                    //console.log('updateDocumentResult = ' + JSON.stringify(updateDocumentResult, null, 2))
                    t.ACT_currentUser(t.form) // Update Current User in Store
                    t.$router.push('/').catch((error) => {
                        console.log(error.message)
                        t.MIX_alert(-1, error.message, null, error)
                    }) // Redirect to Home /
                    break
                case 'VISITOR':
                    // TODO VISITOR CREATE IS STILL TO DO
                    // console.log(JSON.stringify(t.form.host, null, 2))
                    if (t.form.organisation.organisationId !== '') {
                        // Copy Organisation Host Info to Host Name
                        // t.form.host = t.form.organisation.host;

                        // Create New User Account on Firebase Auth / Firestore
                        createUserAccountResult = await t.createUserAccount()
                        t.MIX_alert(
                            createUserAccountResult.code,
                            createUserAccountResult.message,
                            createUserAccountResult.data,
                            createUserAccountResult.error
                        )

                        t.form.id = createUserAccountResult.data.user.uid // Update User ID from Firestore
                        t.ACT_currentUser(t.form) // Update Current User in Store
                        t.$router.push('/').catch((error) => {
                            console.log(error.message)
                            t.MIX_alert(-1, error.message, null, error)
                        }) // Redirect to Home /
                    } else {
                        // Organisation Does not Exist and has been created now so add user / add organisation then update user with organisation info.
                        // Create New User Account on Firebase Auth / Firestore
                        // Update userRole
                        t.form.userRole = 'MANAGER'
                        // t.form.host = t.organisationForm.orgApproval

                        createUserAccountResult = await t.createUserAccount()

                        t.MIX_alert(
                            createUserAccountResult.code,
                            createUserAccountResult.message,
                            createUserAccountResult.data,
                            createUserAccountResult.error
                        )
                        t.form.id = createUserAccountResult.data.user.uid // Update User ID from Firestore

                        // Create Organisation
                        var userData = {}
                        userData = {
                            userId: t.form.id,
                            userName: t.form.userName,
                            userEmail: t.form.userEmail,
                            organisationId: t.form.organisation.organisationId,
                            organisationName: t.form.organisation.organisationName
                        }

                        t.organisationForm.organisationType = t.form.userType
                        t.organisationForm.host = userData
                        t.organisationForm.createdUserData = userData
                        t.organisationForm.createdDateTime = t.$moment().format('x') // add created timestamp to document
                        t.organisationForm.modifiedUserData = userData
                        t.organisationForm.modifiedDateTime = t.$moment().format('x') // add created timestamp to document

                        createOrganisationResult = await t.createOrganisation()

                        if (createOrganisationResult.code === 1) {
                            var organisation = {}
                            organisation.organisationId = t.organisationForm.id
                            organisation.organisationName = t.organisationForm.organisationName
                            organisation.organisationType = t.form.userType

                            var userDataNew = {}
                            userDataNew = {
                                userId: t.form.id,
                                userName: t.form.userName,
                                userEmail: t.form.userEmail,
                                organisationId: organisation.organisationId,
                                organisationName: organisation.organisationName
                            }

                            var fields = {}
                            fields.organisation = organisation
                            fields.createdUserData = userDataNew
                            fields.modifiedUserData = userDataNew
                            fields.createdDateTime = t.$moment().format('x') // add created timestamp to document
                            fields.modifiedDateTime = t.$moment().format('x') // add created timestamp to document
                            fields.host = t.organisationForm.orgApproval
                            fields.userIsHost = true

                            var updateDocumentResult = await t.updateDocument('users', t.form.id, fields)

                            var orgFields = {}
                            orgFields.host = userDataNew
                            orgFields.createdUserData = userDataNew
                            orgFields.modifiedUserData = userDataNew

                            var updateDocumentResult = await t.updateDocument('organisations', t.organisationForm.id, orgFields)
                        }
                        t.MIX_alert(
                            createOrganisationResult.code,
                            createOrganisationResult.message,
                            createOrganisationResult.data,
                            createOrganisationResult.error
                        )
                        // TODO NEED TO UPDATE USER AND ORGANISATINO SEPARATELY

                        t.ACT_currentUser(t.form) // Update Current User in Store
                        t.$router.push('/').catch((error) => {
                            console.log(error.message)
                            t.MIX_alert(-1, error.message, null, error)
                        }) // Redirect to Home /
                    }
                    break
                case 'CONTRACTOR':
                    //console.log('USER TYPE IS CONTRACTOR');
                    // If the host userID is empty then organisation must exist
                    //if (t.form.host.userId === '' || t.form.host === undefined) {
                    if (t.form.organisation.organisationId !== '') {
                        // Copy Organisation Host Info to Host Name
                        // t.form.host = t.form.organisation.host;

                        // Create New User Account on Firebase Auth / Firestore
                        createUserAccountResult = await t.createUserAccount()
                        t.MIX_alert(
                            createUserAccountResult.code,
                            createUserAccountResult.message,
                            createUserAccountResult.data,
                            createUserAccountResult.error
                        )

                        t.form.id = createUserAccountResult.data.user.uid // Update User ID from Firestore
                        t.ACT_currentUser(t.form) // Update Current User in Store
                        t.$router.push('/').catch((error) => {
                            console.log(error.message)
                        }) // Redirect to Home /
                    } else {
                        // Organisation Does not Exist and has been created now so add user / add organisation then update user with organisation info.
                        // Create New User Account on Firebase Auth / Firestore
                        // Update userRole
                        t.form.userRole = 'MANAGER'
                        // t.form.host = t.organisationForm.orgApproval
                        createUserAccountResult = await t.createUserAccount()

                        t.MIX_alert(
                            createUserAccountResult.code,
                            createUserAccountResult.message,
                            createUserAccountResult.data,
                            createUserAccountResult.error
                        )
                        t.form.id = createUserAccountResult.data.user.uid // Update User ID from Firestore

                        // Create Organisation
                        var userData = {}
                        userData = {
                            userId: t.form.id,
                            userName: t.form.userName,
                            userEmail: t.form.userEmail,
                            organisationId: t.form.organisation.organisationId,
                            organisationName: t.form.organisation.organisationName
                        }

                        t.organisationForm.organisationType = t.form.userType
                        t.organisationForm.host = userData
                        t.organisationForm.createdUserData = userData
                        t.organisationForm.createdDateTime = t.$moment().format('x') // add created timestamp to document
                        t.organisationForm.modifiedUserData = userData
                        t.organisationForm.modifiedDateTime = t.$moment().format('x') // add created timestamp to document

                        createOrganisationResult = await t.createOrganisation()

                        if (createOrganisationResult.code === 1) {
                            var organisation = {}
                            organisation.organisationId = t.organisationForm.id
                            organisation.organisationName = t.organisationForm.organisationName
                            organisation.organisationType = t.form.userType

                            var userDataNew = {}
                            userDataNew = {
                                userId: t.form.id,
                                userName: t.form.userName,
                                userEmail: t.form.userEmail,
                                organisationId: organisation.organisationId,
                                organisationName: organisation.organisationName
                            }

                            var fields = {}
                            fields.organisation = organisation
                            fields.createdUserData = userDataNew
                            fields.modifiedUserData = userDataNew
                            fields.createdDateTime = t.$moment().format('x') // add created timestamp to document
                            fields.modifiedDateTime = t.$moment().format('x') // add created timestamp to document
                            // fields.host = t.organisationForm.orgApproval
                            fields.userIsHost = true

                            var updateDocumentResult = await t.updateDocument('users', t.form.id, fields)

                            var orgFields = {}
                            orgFields.host = userDataNew
                            orgFields.createdUserData = userDataNew
                            orgFields.modifiedUserData = userDataNew

                            var updateDocumentResult = await t.updateDocument('organisations', t.organisationForm.id, orgFields)
                        }
                        t.MIX_alert(
                            createOrganisationResult.code,
                            createOrganisationResult.message,
                            createOrganisationResult.data,
                            createOrganisationResult.error
                        )
                        // TODO NEED TO UPDATE USER AND ORGANISATINO SEPARATELY

                        t.ACT_currentUser(t.form) // Update Current User in Store
                        t.$router.push('/').catch((error) => {
                            console.log(error.message)
                        }) // Redirect to Home /
                    }
                    //console.log('FORM DATA \n' + JSON.stringify(t.form, null, 2))
                    break
                default:
                    //console.log('USER TYPE NOT FOUND');
                    break
            }
            // Refresh the page for mobile
            t.MIX_go('/')

            // // * CHECK IF USER WAS CREATED FROM THE ADMIN DASHBOARD
            // var userExists = await this.checkUserInLocalStorage(t.form.userEmail);
            // TODO remove console logs
            // * create user
            // t.$firebase.auth.createUserWithEmailAndPassword(t.form.userEmail, t.password).then((user) => {
            //     // * set user details
            //     t.setUserDetails(user.user.uid);
            //     // * add to the users collection
            //     t.form.authId = user.user.uid;
            //     t.$firebase.db.collection("users").doc(user.user.uid).set(t.form).then((Result) => {
            //         // console.log("result: " + Result);
            //       }).catch((err) => {
            //         console.log(err);
            //       });
            //     t.accountCreated = true;
            //     // * assign this user to the current logged in user
            //     t.ACT_currentUser(user)
            //     this.MIX_alert(1, "Your account was created.", null, null);
            //     // * send verification email to user
            //     t.sendVerificationEmail(t.$firebase.auth.currentUser);
            //     // * redirect user to homepage
            //     t.redirectToHomepage();
            // })
            // .catch((err) => {
            //     // ! firebase registering error
            //     t.registerErrorMessage = err;
            //     t.accountCreated = false;
            //     console.log("firebase registering error: " + err);
            //     t.MIX_alert(-1, err, null, null);
            // });
        },
        // * GET STAFF CONTACTS - REQUIRED FOR LIST OF APPROVED STAFF CONTACTS FOR TFW SPONSOR FIELD, THIS PERSON WILL BE SENT NOTIFICATION TO APPROVE ACCOUNT
        getStaffContacts: async function () {
            return new Promise((resolve) => {
                let t = this

                t.$firebase.db
                    .collection('users')
                    .where('userStaffContact', '==', true)
                    .where('userStatus', '==', 'APPROVED')
                    .onSnapshot(function (querySnapshot) {
                        t.staffContactResult = []
                        querySnapshot.forEach(function (doc) {
                            var document = doc.data()
                            document.id = doc.id
                            if (!document.hasOwnProperty('delete')) {
                                t.staffContactResult.push(document)
                            } else if (t.showDeletedComments) {
                                t.staffContactResult.push(document)
                            } else {
                                // Do not Show Notice
                            }
                        })

                        t.staffContactResult = t.$sortBy(t.staffContactResult, 'userJobTitle')
                    })

                // var url = t.MIX_cloudFunctionsAPI + 'getStaffContacts';
                // t.$axios({ method: 'get', url })
                //     .then((response) => {
                //         this.staffContactResult = t.$sortBy(response.data.data, 'userJobTitle');
                //         resolve();
                //         // console.log("staffContactResult = " + JSON.stringify(t.staffContactResult, null, 2))
                //     })
                //     .catch((error) => console.log('getStaffContacts error occured\n' + error))
            })
        },
        // * GET ORGANISATIONS - REQUIRED FOR A LIST OF SEARCHABLE ORGANISATIONS
        getOrganisations: async function () {
            return new Promise((resolve) => {
                let t = this
                var url = t.MIX_cloudFunctionsAPI + 'getApprovedOrganisations'
                t.$axios({ method: 'get', url })
                    .then((response) => {
                        var organisations = []
                        response.data.data.forEach((organisation) => {
                            if (!organisation.hasOwnProperty('delete')) {
                                organisations.push(organisation)
                            }
                        })
                        t.organisations = t.$sortBy(organisations, 'organisationName')
                        //console.log(" organisations = " + JSON.stringify(organisations, null, 2))
                        resolve()
                    })
                    .catch((error) => console.log('getApprovedOrganisations error occured\n' + error))
            })
        },
        // * GET SITES - REQUIRED FOR A LIST OF SEARCHABLE ORGANISATIONS
        getSites: async function () {
            return new Promise((resolve) => {
                let t = this
                var url = t.MIX_cloudFunctionsAPI + 'getApprovedSites'
                t.$axios({ method: 'get', url })
                    .then((response) => {
                        var sites = []
                        response.data.data.forEach((site) => {
                            if (!site.hasOwnProperty('delete')) {
                                sites.push(site)
                            }
                        })
                        t.sites = t.$sortBy(sites, 'siteName')
                        //console.log(" 2 = " + JSON.stringify(t.sites, null, 2))
                        resolve()
                    })
                    .catch((error) => console.log('getApprovedSites error occured\n' + error))
            })
        }
    },
    async mounted() {
        let t = this
        await t.getOrganisations()
        await t.getSites()
        await t.getStaffContacts()
        // * GET SITES
    }
}
//# sourceURL=settings.vue
</script>

<style scoped>
.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
</style>
<style>
.mdi-asterisk {
    color: black !important;
    font-size: 10px !important;
}
</style>
